
let environment;

// Detectar entorno automáticamente
const hostname = window.location.hostname;
const isLocal = hostname === 'localhost' || 
                hostname === '127.0.0.1' ||
                window.location.port === '3000' ||
                hostname.includes('ngrok') ||
                hostname.includes('ngrok-free.dev') ||
                hostname.includes('ngrok.io');

// Detectar si es test/development
const isTest = hostname.includes('test.app.edify.la');

// Detectar si es producción
const isProduction = hostname.includes('app.edify.la');


if (isLocal) {
  environment = require('./local.js').default;
} else if (isTest) {
  environment = require('./development.js').default;
} else if (isProduction) {
  environment = require('./production.js').default;
} else {
  environment = require('./development.js').default;
}

export default environment;
